<div class="container-xxl">
  <div class="row">
    <div class="wrapper">
      @if (media) {
        <mb-media
          [media]="media"
          [autoplay]="true"
          [muted]="true"
          [controls]="false"
          [loop]="true"
          [hideTitles]="true"
          [playsInline]="true"
        ></mb-media>
      }
      <div class="content-outer">
        @if (titleHash) {
          <div class="title-hash-container">
            <span>{{ titleHash }}</span>
          </div>
        }

        <div class="content-inner">
          @if (title) {
            <div class="title-container">
              <span class="font-family-title" [innerHTML]="title"></span>
            </div>
          }
          @if (links.length) {
            <div class="button-container">
              @for (item of links; track item.link) {
                @if (item.label) {
                  <a [routerLink]="[item.link]" [queryParams]="item.queryParams || {}" class="btn">
                    {{ item.label }}
                  </a>
                }
              }
            </div>
          }

          @if (subtitle) {
            <div class="subtitle-container" [innerHTML]="subtitle"></div>
          }
          @if (fuelLabel) {
            <div class="fuel-label-container copy-s">
              <p class="copy-s" [innerHTML]="fuelLabel"></p>
            </div>
          }
        </div>
      </div>

      @if (teasers.length && !hideAnnouncements) {
        <div class="row announcements">
          @for (teaser of teasers; track $index) {
            <mb-announcement
              class="col"
              [title]="teaser.title"
              [subtitle]="teaser.subtitle"
              [countdownDate]="teaser.countdownDate"
              [countdownLabel]="teaser.countdownLabel"
              [postCountdownLabel]="teaser.postCountdownLabel"
              [showDaysOnly]="teaser.showDaysOnly"
              [isBelowCountdown]="isBelowCountdown"
            ></mb-announcement>
          }
        </div>
      }
    </div>
  </div>
</div>
